import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../store';
import contactService from '../../services/contacts';
import { 
  Contact,
  ContactFilterValues,
  ContactPayload,
  ContactSortValues,
  ContactState,
  SiteContact,
  SitePayload,
} from '../types';
import { notify } from './notificationSlice';
import { getErrorMsg } from '../../utils/helperFuncs';
import { updateSiteContact, updateSiteState } from './sitesSlice';

interface InitialContactState {
//  contacts: { [siteId: string]: ContactState[] };
//  contacts: Contact[];
  contacts: ContactState[]; // previously disabled 230316
  fetchLoading: boolean;
  fetchError: string | null;
  submitLoading: boolean;
  submitError: string | null;
  sortBy: ContactSortValues,
  filterBy: ContactFilterValues,
//  status: 'idle' | 'loading' | 'succeeded';
//  error: string | null;
}

const initialState: InitialContactState = {
  contacts: [],
  fetchLoading: false,
  fetchError: null,
  submitLoading: false,
  submitError: null,
  sortBy: 'newest',
  filterBy: 'all',
/*  contacts: [],
  status: 'idle',
  error: null,*/
};

const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
//    setContacts: (state, action: PayloadAction<{ contact: ContactState[], siteId: string }>) => { //230320
    //setContacts: (state, action: PayloadAction<Contact[]>) => {
    setContacts: (state, action: PayloadAction<ContactState[]>) => {
      state.contacts = action.payload;
//      state.contacts[action.payload.siteId] = action.payload.contact;   //230320
      state.fetchLoading = false;
//      state.status = 'succeeded';
      state.fetchError = null;
    },
    addContact: (
      state,
      action: PayloadAction<{
        data: ContactState;
        siteId: string;
      }>
    ) => {
      if (action.payload.data !== undefined) {
        state.contacts.push(action.payload.data);
      }
      state.submitLoading= false;
      state.submitError = null;
//    setSiteContacts: (state, action: PayloadAction<{ contact: Contact, siteId: string }>) => {
    },
    addSite2LinkedContact: (
      state,
      action: PayloadAction<{ contactId: string; siteId: string }>
    ) => {
      state.contacts.find((c) => 
        c.id === action.payload.contactId
      )?.site_id.push(Number(action.payload.siteId))
    },
    setSiteContacts: (state, action: PayloadAction<{ contact: ContactState, site_id: string }>) => {
      //setContacts: (state, action: PayloadAction<ContactState[]>) => {
      //state.contacts[action.payload.siteId] = action.payload.contact.;
/*      state.contacts[action.payload.contact.id] = action.payload;
      state.fetchLoading = false;
//      state.status = 'succeeded';
      state.fetchError = null;*/
    },
    setContactsLoading: (state) => {
      state.fetchLoading = true;
//      state.status = 'loading';
      state.fetchError = null;
    },
    setFetchContactsError: (state, action: PayloadAction<string>) => {
      state.fetchLoading = false;
      state.fetchError = action.payload;
    },
    sortContactsBy: (state, action: PayloadAction<ContactSortValues>) => {
      state.sortBy = action.payload;
    },
    setSubmitContactLoading: (state) => {
      state.submitLoading = true;
      state.submitError = null;
    },
    setSubmitContactError: (state, action: PayloadAction<string>) => {
      state.submitLoading = false;
      state.submitError = action.payload;
    },
    clearSubmitContactError: (state) => {
      state.submitError = null;
    },
  },
});

export const { 
  setContacts,
  addContact,
  setSiteContacts,
  addSite2LinkedContact,
  setContactsLoading,
  setFetchContactsError,
  sortContactsBy,
  setSubmitContactLoading,
  setSubmitContactError,
  clearSubmitContactError
} = contactsSlice.actions;

export const addSite2Contact = (
  contactId: string,
  siteId: string,
//  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    console.log("pass par là ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
    try {
      //@ts-ignore
      dispatch(setSubmitContactLoading());
      dispatch(addSite2LinkedContact({contactId,siteId}))
      dispatch(notify("Contact mis à jour!", 'success'));
//      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitContactError(getErrorMsg(e)));
    }
  };
};

export const updateContact = (
  siteId: string,
  contactData: ContactPayload,
//  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    console.log("pass par là ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
    try {
      //@ts-ignore
      dispatch(setSubmitContactLoading());
      const updatedSite: SitePayload = await contactService.updateContact(siteId, contactData);
      if(updatedSite !== undefined && updatedSite?.contacts !== undefined) { 
        let burp: Contact[] = updatedSite.contacts
        dispatch(updateSiteState({data: {updatedSite}, siteId}))
        console.log('Contact mis à jour !!')
        dispatch(notify('Contact mis à jour', 'success')); }
      else {
        dispatch(setSubmitContactError(getErrorMsg(e)));
        dispatch(notify("Infos contact NON mises à jour :-(", 'success'));
      } 
//      closeDialog && closeDialog();
//      dispatch(notify("Infos contact mises à jour!", 'success'));
//      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitContactError(getErrorMsg(e)));
    }
  };
};
export const createContact = (
  siteId: string,
  contactData: ContactPayload,
//  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      //@ts-ignore
      dispatch(setSubmitContactLoading());
      const updatedSite: SitePayload = await contactService.createContact(siteId, contactData);
      if(updatedSite !== undefined && updatedSite?.contacts !== undefined) { 
//        dispatch(addContact({data: { updatedSite },siteId}));
        const { 
          id,
          nom,
          prenom,
          mail,
          tel,
          adresse,
          code_postal,
          actif,
          revenus,
          remarques,
          site_id,
          site_sn
        } = updatedSite.contacts[0] as Contact;
        dispatch(addContact({
          data: { 
            id: String(id),
            nom: nom,
            prenom: prenom,
            mail: mail,
            tel: tel,
            adresse: adresse,
            code_postal: code_postal,
            actif: actif,
            revenus: revenus,
            remarques: remarques,
            site_id: site_id,
            site_sn: site_sn
          },
          siteId}));
        dispatch(updateSiteState({data: { updatedSite },siteId}))
        dispatch(notify('Contact ajouté', 'success')); }
      else {
        dispatch(setSubmitContactError(getErrorMsg(e)));
      } 
//      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitContactError(getErrorMsg(e)));
    }
  };
};

export const fetchContactsBySiteId = (site_id: string): AppThunk => {
  return async (dispatch) => {
    try {
      //@ts-ignore
      dispatch(setContactsLoading());
      const siteContacts = await contactService.getSiteContacts(site_id);
//      dispatch(setSiteContacts({ contacts: contactState ??, siteId }));
      dispatch(setSiteContacts({ contact: siteContacts, site_id }));
    } catch (e) {
      //@ts-ignore
      dispatch(setFetchContactsError(getErrorMsg(e)));
      //@ts-ignore
      dispatch(notify(getErrorMsg(e), 'error'));    }
  };
};

export const fetchContacts = (): AppThunk => {
  return async (dispatch) => {
    try {
      //@ts-ignore
      dispatch(setContactsLoading());
      const allContacts = await contactService.getContacts();
      dispatch(setContacts(allContacts));
    } catch (e) {
      //@ts-ignore
      dispatch(notify(getErrorMsg(e), 'error'));
    }
  };
};

export const selectContactsBySiteId = (state: RootState, site_id: string) => {
  return state.contacts.contacts?.[Number(site_id)];
  //return state.contacts.contacts?.[Number(siteId)];
};

export const selectContactsState = (state: RootState) => state.contacts;
export const selectContactById = (
  state: RootState,
  site_id: string,
  contactId: string) => {
	  return state.contacts.contacts?.[Number(site_id)]; //.find((p) => p.id === contactId);
//    return state.contacts.contacts/*?.[Number(siteId)]*/.find((p) => p.id === contactId);
};

export default contactsSlice.reducer;
